import ShareIcon from "@material-ui/icons/Share";
import { useStyles } from "./style";
const ShareComponent = ({ url, title, text }) => {
  const classes = useStyles();

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          text,
          url,
        });
      } catch (error) {
        console.error(error);
      }
    }
  };
  return <ShareIcon className={classes.ShareIcon} onClick={handleShare} />;
};

export default ShareComponent;
